<script lang="ts">
  import type { IntegrationDetails, ExternalContacts } from "../../helpers/types";
  import StepSuccessIcon from "./StepSuccessIcon.svelte";
  import { saveSiteMapping } from "../../helpers/integrations-api";
  import { setupStepStore } from "../../stores/integrations-store";
  import { track } from "../../helpers/mixpanel";
  import { selectedBuyer } from "../../stores/buyer";
  import { saveSquareLocation } from "../../api/integrations";

  export let integration: IntegrationDetails;
  export let contacts: ExternalContacts | null;
  export let onSiteSelected = (_siteId: string) => {};
  export let stepNumber: number = 0;
  export let currentStep: number = 0;
  export let isActive: boolean = false;
  export let authenticated: boolean = false;
  export let subtitle: string = "select organisation";

  const sites =
    integration.platform == "Tevalis"
      ? Object.values(contacts?.sites || {})
      : Object.keys(contacts?.sites || {});

  if (!integration.site_id && Object.keys(contacts?.sites || []).length === 1) {
    integration.site_id = Object.keys(contacts?.sites || [])[0];
  }

  $: siteSelected =
    (integration.site_id && sites.includes(integration.site_id)) ||
    (authenticated && integration.site_id && !Object.keys(sites).length);

  $: active = (stepNumber && authenticated && isActive) || (authenticated && !stepNumber);

  const updateSiteMapping = (e: any) => {
    const siteId: string = e.target.value;

    track("integration_external_site_update", {
      buyer_id: $selectedBuyer?.id,
      buyer_name: $selectedBuyer?.name,
      integration_id: integration.id,
      platform: integration.platform,
      external_site_id: siteId,
      type: stepNumber ? "setup" : "management",
    });

    if (!siteId) {
      return;
    }

    if (integration.site_id === siteId) {
      onSiteSelected(siteId);
      siteSelected = true;
    }

    saveSiteMapping(siteId, integration.setup_token).then((result) => {
      onSiteSelected(result.site_id);
      siteSelected = !!siteId;
    });

    if (integration.platform === "Square") {
      saveSquareLocation({
        buyer_id: $selectedBuyer?.id || "",
        location_id: siteId,
        integration_id: integration.id,
      });
    }
  };
</script>

<div class="container">
  <div class="supply-line-header">
    <StepSuccessIcon success={!!siteSelected} {isActive} {stepNumber} />
    <h4 class="subtitle">{subtitle}</h4>
    {#if authenticated && currentStep > stepNumber}
      <button class="contact-us-btn btn-neutral" on:click={() => setupStepStore.set(stepNumber)}
        >edit
      </button>
    {/if}
  </div>
  {#if active}
    <div class="content">
      <div class="supply-line-row">
        <div class="select-container">
          <select on:change={updateSiteMapping} value={integration.site_id || ""}>
            <option value={""} selected>Select Site</option>
            {#each Object.entries(contacts?.sites || {}) as site}
              {#if integration.platform === "Tevalis"}
                <option value={site[1]}>{site[0]}</option>
              {:else}
                <option value={site[0]}>{site[1]}</option>
              {/if}
            {/each}
          </select>
        </div>
      </div>
    </div>
  {/if}
</div>

<style>
  .container {
    border-radius: 8px;
    background-color: white;
    margin-bottom: 18px;
  }

  .supply-line-header {
    display: flex;
    padding: 18px;
    border-bottom: 1px solid;
    border-color: var(--rekki-neutral-01);
    align-items: center;
  }
  .content {
    padding: 18px;
  }

  .supply-line-row {
    display: flex;
    margin-bottom: 18px;
    align-items: center;
  }

  .select-container {
    margin-left: auto;
    justify-content: flex-end;
    display: flex;
    flex: 1;
  }

  select {
    border: none;
    background-color: var(--rekki-neutral-01);
    border-radius: 8px;
    font-size: 18px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    height: 60px;
    padding-left: 8px;
    padding-right: 8px;
    margin-left: 8px;
    min-width: 180px;
    flex: 1;
  }

  .subtitle {
    font-size: 18px;
    font-weight: bold;
  }

  .contact-us-btn {
    border-radius: 100px;
    padding: 10px 20px;
    background-color: var(--rekki-accent);
    color: var(--rekki-light);
    border: none;
    justify-self: flex-end;
    font-family: "REKKI-OCD";
    white-space: nowrap;
    text-transform: uppercase;
    margin-left: auto;
    font-size: 16px;
  }

  .btn-neutral {
    background-color: var(--rekki-neutral-01);
    color: var(--rekki-dark);
  }
</style>
